import React from "react";
import "./Insta.css";

function InstaIntegration() {
  return (
    // <!-- LightWidget WIDGET -->
    <>
      <h1 className="insta-title">Follow Us On Instagram!</h1>
      <div className="instagram-container">
        <script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></script>
        <iframe
          src="//lightwidget.com/widgets/14f965ca615a5e559089e42c39e0db32.html"
          // scrolling="no"
          allowtransparency="true"
          class="lightwidget-widget"
          style={{ border: "0px", overflow: "hidden" }}
        ></iframe>
      </div>
    </>
  );
}

export default InstaIntegration;
